module.exports = __webpack_public_path__ + "static/media/main idea.f1bde8f1.mp3";